import { call, put, takeEvery } from '@redux-saga/core/effects';
import { createAction, handleActions } from 'redux-actions';
import { defaultGridData } from '../../../module/component/TableBoxModule';
import { PATH_DELIMITER, SEMESTER_SUBJECT_PATH } from '../../../constant/Constant';
import NullCheckUtil from '../../../util/NullCheckUtil';
import { request } from '../../ApiModule';
import { SET_GRID_DATA } from '../../component/TableBoxModule';

const ACTION_SEARCH = SEMESTER_SUBJECT_PATH + PATH_DELIMITER + 'ACTION_SEARCH';
const ACTION_EXCEL_DOWNLOAD = SEMESTER_SUBJECT_PATH + PATH_DELIMITER + 'ACTION_EXCEL_DOWNLOAD';
const ACTION_EXCEL_UPLOAD = SEMESTER_SUBJECT_PATH + PATH_DELIMITER + 'ACTION_EXCEL_UPLOAD';

export const actionSearch = createAction(ACTION_SEARCH);
export const actionExcelDownload = createAction(ACTION_EXCEL_DOWNLOAD);
export const actionExcelUpload = createAction(ACTION_EXCEL_UPLOAD);

export function* semesterSubjectSagas() {
    yield takeEvery(ACTION_SEARCH, actionSearchSaga);
    yield takeEvery(ACTION_EXCEL_DOWNLOAD, actionExcelDownloadSaga);
    yield takeEvery(ACTION_EXCEL_UPLOAD, actionExcelUploadSaga);
}

function* actionSearchSaga({ payload: { params, callback } }) {
    const result = yield call(request, {
        method: 'get',
        url: `/api/course/semesters/${params.semesterId}/universities/${params.lessonUniversityCd}/semester`,
        params,
        callback,
    });
    if (NullCheckUtil.isNotNull(result)) {
        yield put({
            type: SET_GRID_DATA,
            payload: {
                ...result,
                rows: result.rows.map((row) => ({ ...row.courseInfo, courseTimes: row.courseTimes })),
            },
        });
    }
}

function* actionExcelDownloadSaga({ payload: { params } }) {
    yield call(request, {
        method: 'get',
        url: '/api/course/excel-export',
        params,
        download: true,
        downloadDirect: true,
        downloadType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
}

function* actionExcelUploadSaga({ payload: { params, callback, uploadProgress } }) {
    const formData = new FormData();
    formData.append('excelFile', params.file);
    const result = yield call(request, {
        method: 'post',
        url: '/api/course/excel-import',
        data: formData,
        upload: true,
        uploadProgress,
        callback,
    });
}
